import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Errors } from 'src/infrastructure/labels/errors';
import { Successes } from 'src/infrastructure/labels/successes';
import { ValidationConfig } from 'src/infrastructure/validation/validationConfig';
import { Validator } from 'src/infrastructure/validation/validator';
import { ToastService } from 'src/services/core/toast/toast.service';
import { ForgottenpasswordService } from 'src/services/request/forgottenpassword/forgottenpassword.service';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-forgottenpassword',
  templateUrl: './forgottenpassword.component.html',
  styleUrls: ['./forgottenpassword.component.css']
})
export class ForgottenpasswordComponent extends HistoryBaseComponent  implements OnInit {

  forgottenPasswordInfo: FormGroup;

  constructor(
    private FB: FormBuilder,
    private forgottenPasswordService: ForgottenpasswordService,
    private toast: ToastService,
    protected router: Router,
    protected location: Location,
    protected historyService: HistoryService

  ) { 

  super(location, historyService);
    this.pageTitle = "forgottenpassword";
    this.forgottenPasswordInfo = FB.group({
      email: ['', [Validators.required, Validators.pattern(ValidationConfig.regexes.email)]]
    })
  }

  ngOnInit(): void {
  }


  send() {
    this._error = Validator.FormGroupValidator.validate(this.forgottenPasswordInfo);
    if (this._error) {
      this.toast.error(Errors.bg.invalidEmail)
      return;
    }
    const email = this.forgottenPasswordInfo.get('email')?.value;
    if (!Validator.InputValidator.email.validate(email)) {
      this._error = Errors.bg.invalidEmail;
      return;
    }
    this.forgottenPasswordService.initiateResetPassword({ email: email}).subscribe(() => {
      this.toast.success(Successes.bg.resetPasswordEmail);
      this.router.navigate(['email/sent']);
    })
  }
}
